@import '../../../theme.scss';

// Your periodic reminder that it's 2022 and you still can't style HTML checkboxes
verdocs-checkbox {
  line-height: 18px;
  font-family: $verdocs-primary-font;

  label>input[type='checkbox'] {
    display: none;
  }

  label>input[type='checkbox']+*::before {
    content: '';
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-right: 8px;
    line-height: 20px;
    border-radius: 2px;
    border-style: solid;
    border-width: 0.1rem;
    display: inline-block;
    vertical-align: bottom;
    border-color: $verdocs-grey-2;
  }


  label>input[type='checkbox']:checked+*::before {
    content: '✓';
    color: white;
    text-align: center;
    background: var(--verdocs-checkbox-color, $verdocs-green);
    border-color: var(--verdocs-checkbox-color, $verdocs-green);
  }

  &.dark {
    label>input[type='checkbox']+*::before {
      border-color: $verdocs-grey-4;
    }

    label>input[type='checkbox']:checked+*::before {
      background: var(--verdocs-checkbox-color, $verdocs-green);
      border-color: var(--verdocs-checkbox-color, $verdocs-green);
    }
  }

  &.small {
    label>input[type='checkbox']+*::before {
      width: 16px;
      height: 16px;
      line-height: 16px;
    }
  }
}